/** @format */

import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import FileImportServiceList from './FileImportServiceList';
import ServiceListUploadList from './ServiceListUploadList';

const ServiceListManager: React.FC = () => {
    const [reload, setReload] = useState<boolean>(false);

    useEffect(() => {
        if (reload) {
            setReload(false);
        }
    }, [reload]);
    return (
        <Grid container spacing={2}>
            <Grid item xs={3}>
                <FileImportServiceList reload={reload} setReload={setReload} />
            </Grid>
            <Grid item xs={12}>
                <ServiceListUploadList reload={reload} setReload={setReload} />
            </Grid>
        </Grid>
    );
};

export default ServiceListManager;
